// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__E__fL","copyrights":"Footer_copyrights__u8N48","legal":"Footer_legal__YRnN4","socials":"Footer_socials__GFWEX","logo":"Footer_logo__TTTno"};